import React from "react";
import validator from "validator";
import { injectIntl } from "react-intl";
import { countries, states } from "../player/utils/utils";
import { loadStripe } from "@stripe/stripe-js";
import { loadScript } from "@paypal/paypal-js";
import MsPanelButton from "./ms-panel-button.jsx";
import MsField from "./ms-field.jsx";
import MsDropdown from "./ms-dropdown.jsx";
import MSStreamLoader from "./ms-stream-loader.jsx";
import MsFeatherIcon from "./ms-feather-icon.jsx";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const PAYMENT_STEPS = [
    { id: "payment-billing", number: 1, title: "Billing", description: "Contact & address", icon: "credit-card" },
    { id: "payment-review", number: 2, title: "Review", description: "Order summary", icon: "clipboard" },
    { id: "payment-purchase", number: 3, title: "Purchase", description: "Payment", icon: "shopping-bag" },
];

class MSStreamPurchase extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            stepId: "payment-billing",
            showPanel: true,
            billingCompleted: false,
            reviewCompleted: false,
            pruchaseCompleted: false,
            errorMessage: "",
            firstName: this.props.userData.first_name ?? "",
            firstNameError: false,
            lastName: this.props.userData.last_name ?? "",
            lastNameError: false,
            email: this.props.userData.email ?? "",
            emailError: false,
            phone: this.props.userData.phone ?? "",
            phoneError: false,
            address: this.props.userData.address ?? "",
            addressError: false,
            postcode: this.props.userData.postcode ?? "",
            postcodeError: false,
            city: this.props.userData.city ?? "",
            cityError: false,
            country: this.props.userData.country ?? "CA",
            countryError: false,
            state: this.props.userData.state ?? "",
            stateError: false,
            purchasedDisabled: false,
            isAccessCode: true,
            paymentProcessing: false,
        };

        this.paymentGateway = this.props.wcdata[3] ? this.props.wcdata[3] : "";
        this.paymentKey = this.props.wcdata[4] ? this.props.wcdata[4] : "";

        console.log('payment gateway');
        console.log(this.paymentGateway);

        this.stripe = null;
        this.number = null;
        this.cvc = null;
        this.expiry = null;
        this.stripeMounted = false;
        this.stripeInitPromise = null;
        this.paypalMounted = false;

        this.showBilling = this.showBilling.bind(this);
        this.doPayment = this.doPayment.bind(this);
        this.displayBilling = this.displayBilling.bind(this);
        this.displayReview = this.displayReview.bind(this);
        this.displayPayment = this.displayPayment.bind(this);
        this.goPreviousPanel = this.goPreviousPanel.bind(this);
        this.setFirstName = this.setFirstName.bind(this);
        this.setLastName = this.setLastName.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setPhone = this.setPhone.bind(this);
        this.setAddress = this.setAddress.bind(this);
        this.setPostcode = this.setPostcode.bind(this);
        this.setCity = this.setCity.bind(this);
        this.setCountry = this.setCountry.bind(this);
        this.setCityState = this.setCityState.bind(this);
        this.gatewayPaymentForm = this.gatewayPaymentForm.bind(this);
        this.validateBillingFields = this.validateBillingFields.bind(this);
        this.loadPaypalFunction = this.loadPaypalFunction.bind(this);
        this.loadStripeFunction = this.loadStripeFunction.bind(this);
        this.initPaymentGateway = this.initPaymentGateway.bind(this);
        this.destroyPaymentGateway = this.destroyPaymentGateway.bind(this);
        this.processAccessPayment = this.processAccessPayment.bind(this);
        this.processRegPayment = this.processRegPayment.bind(this);
        this.goSuccessPanel = this.goSuccessPanel.bind(this);
    }

    componentDidMount() {
        if (this.state.stepId === "payment-review") {
            this.initPaymentGateway();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showPanel && !this.state.showPanel) {
            this.destroyPaymentGateway();
        }
        if (
            prevState.stepId !== this.state.stepId &&
            this.state.stepId === "payment-review"
        ) {
            this.initPaymentGateway();
        }
        if (
            !prevState.showPanel &&
            this.state.showPanel &&
            this.state.stepId === "payment-review"
        ) {
            this.initPaymentGateway();
        }
    }

    componentWillUnmount() {
        this.destroyPaymentGateway();
    }

    initPaymentGateway() {
        if (!this.paymentKey) {
            return;
        }
        if (this.paymentGateway === "stripe") {
            this.loadStripeFunction(this, this.paymentKey);
        } else if (this.paymentGateway === "paypal") {
            this.loadPaypalFunction(this, this.paymentKey);
        }
    }

    destroyPaymentGateway() {
        [this.number, this.expiry, this.cvc].forEach((element) => {
            if (!element) {
                return;
            }
            try {
                element.unmount();
            } catch (_err) {
                /* already unmounted */
            }
            try {
                element.destroy();
            } catch (_err) {
                /* already destroyed */
            }
        });
        this.number = null;
        this.expiry = null;
        this.cvc = null;
        this.stripe = null;
        this.stripeMounted = false;
        this.stripeInitPromise = null;

        const paypalContainer = document.getElementById("paypal-button-container");
        if (paypalContainer) {
            paypalContainer.innerHTML = "";
        }
        this.paypalMounted = false;
    }

    setFirstName(newFirstName) {
        this.setState({ firstName: newFirstName });
    }

    setLastName(newLastName) {
        this.setState({ lastName: newLastName });
    }

    setEmail(newEmail) {
        this.setState({ email: newEmail });
    }

    setPhone(newPhone) {
        this.setState({ phone: newPhone });
    }

    setAddress(newAddress) {
        this.setState({ address: newAddress });
    }

    setPostcode(newPostcode) {
        this.setState({ postcode: newPostcode });
    }

    setCity(newCity) {
        this.setState({ city: newCity });
    }

    setCountry(newCountry) {
        if (newCountry != this.state.country) {
            this.setState({ country: newCountry, state: "" });
        }
    }

    setCityState(newState) {
        this.setState({ state: newState });
    }

    goPreviousPanel() {
        console.log("-----> GO BACK!!", this.props.backScreen);
        this.props.backScreen();
    }

    goSuccessPanel() {
        console.log("-----> GO Success!!", this.props.successScreen);
        this.props.successScreen();
    }

    gatewayPaymentForm() {
        let component = null;
        if (this.paymentGateway == "stripe") {
            component = (
                <>
                    <div className="field">
                        <fieldset className="formRow">
                            <div
                                id="city_field"
                                className="ui icon formRow--input-wrapper active"
                            >
                                <div
                                    id="card-number"
                                    className="form-row-wide stripe-text"
                                ></div>
                                <span className="placeholder">Card Number</span>
                            </div>
                        </fieldset>
                        <div id="card-number-error" style={{ color: "red" }}>
                            {" "}
                        </div>
                    </div>
                    <div className="field">
                        <fieldset className="formRow">
                            <div
                                id="city_field"
                                className="ui icon formRow--input-wrapper active"
                            >
                                <div
                                    id="card-expiry"
                                    className="form-row-wide stripe-text"
                                ></div>
                                <span className="placeholder">Expiry Date</span>
                            </div>
                        </fieldset>
                        <div
                            id="card-expiry-error"
                            style={{ color: "red" }}
                        ></div>
                    </div>
                    <div className="field">
                        <fieldset className="formRow">
                            <div
                                id="city_field"
                                className="ui icon formRow--input-wrapper active"
                            >
                                <div
                                    id="card-cvc"
                                    className="form-row-wide stripe-text"
                                ></div>
                                <span className="placeholder">CVC</span>
                            </div>
                        </fieldset>
                        <div id="card-cvc-error" style={{ color: "red" }}></div>
                    </div>
                </>
            );
        }
        if (this.paymentGateway == "paypal") {
            let paypalStyle = {
                overflow: "auto",
                maxHeight: "350px",
                width: "100%",
                margin: "2px",
            };

            component = (
                <div style={paypalStyle}>
                    <div id="paypal-button-container"></div>
                </div>
            );
        }

        return component;
    }

    validateBillingFields() {
        let isAllOk = true;
        this.setState({
            firstNameError: false,
            lastNameError: false,
            emailError: false,
            phoneError: false,
            addressError: false,
            postcodeError: false,
            cityError: false,
            countryError: false,
            stateError: false,
            errorMessage: "",
        });

        if (this.state.firstName == "") {
            this.setState({ firstNameError: true });
            isAllOk = false;
        }

        if (this.state.lastName == "") {
            this.setState({ lastNameError: true });
            isAllOk = false;
        }

        if (this.state.email == "") {
            this.setState({ emailError: true });
            isAllOk = false;
        }

        if (this.state.phone == "") {
            this.setState({ phoneError: true });
            isAllOk = false;
        }

        if (this.state.address == "") {
            this.setState({ addressError: true });
            isAllOk = false;
        }

        if (this.state.postcode == "") {
            this.setState({ postcodeError: true });
            isAllOk = false;
        }

        if (this.state.city == "") {
            this.setState({ cityError: true });
            isAllOk = false;
        }

        if (this.state.country == "") {
            this.setState({ countryError: true });
            isAllOk = false;
        }

        if (this.state.state == "") {
            this.setState({ stateError: true });
            isAllOk = false;
        }

        if (!validator.isEmail(this.state.email)) {
            this.setState({
                emailError: true,
                errorMessage: "Invalid Email.",
            });
            return;
        }

        // check mobile number is not empty
        if (this.state.phone == "") {
            this.setState({
                phoneError: true,
                errorMessage: "Invalid Phone Number.",
            });
            return;
        }

        let localePost = this.state.country == "" ? "any" : this.state.country;
        if (!validator.isPostalCode(this.state.postcode, localePost)) {
            this.setState({
                postcodeError: true,
                errorMessage: "Invalid Post Code.",
            });
            return;
        }

        if (!isAllOk) {
            this.setState({ errorMessage: "Missing Information." });
            return;
        }

        this.setState({
            stepId: "payment-review",
            billingCompleted: true,
        });
    }

    showBilling() {
        this.destroyPaymentGateway();
        this.setState({
            stepId: "payment-billing",
        });
    }

    processAccessPayment(purchaseData) {
        this.setState({ errorMessage: "" });

        return new Promise(async (resolve, reject) => {
            if (this.paymentGateway == "stripe") {
                var displayError = document.getElementById("card-error");
                await this.stripe
                    .createPaymentMethod({
                        type: "card",
                        card: this.number,
                        billing_details: {
                            name:
                                this.state.firstName +
                                " " +
                                this.state.lastName,
                            address: {
                                line1: this.state.address,
                                // line2: ,
                                city: this.state.city,
                                state: this.state.state,
                                country: this.state.country,
                                postal_code: this.state.postcode,
                            },
                        },
                    })
                    .then(async (result) => {
                        if (result.error) {
                            // Display error.message in your UI
                            displayError.textContent = result.error.message;
                            this.setState({
                                showPanel: true,
                                paymentProcessing: false,
                                errorMessage: "Payment not completed.",
                            });
                        } else {
                            // You have successfully created a new PaymentMethod
                            purchaseData.card_info = {
                                source_id: result.paymentMethod.id,
                                method: "stripe",
                            };
                            this.setState({
                                showPanel: false,
                                paymentProcessing: true,
                                errorMessage: "",
                            });
                            //code to make call to the server
                            this.props.restMS.restRequest(
                                "pac",
                                { purchaseData: purchaseData },
                                (resp) => {
                                    //- console.log(resp);
                                    if (resp.success) {
                                        this.setState({
                                            showPanel: true,
                                            paymentProcessing: false,
                                            stepId: "payment-purchase",
                                            isAccessCode: true,
                                            reviewCompleted: true,
                                            pruchaseCompleted: true,
                                        });
                                    } else {
                                        this.setState({
                                            showPanel: true,
                                            paymentProcessing: false,
                                            stepId: "payment-review",
                                            errorMessage: resp.data,
                                        });
                                    }
                                },
                                (err) => {
                                    this.setState({
                                        showPanel: true,
                                        paymentProcessing: false,
                                        stepId: "payment-review",
                                        errorMessage: "Payment not completed.",
                                    });
                                },
                            );
                        }
                    });
            } else {
                this.setState({
                    showPanel: true,
                    paymentProcessing: false,
                    errorMessage:
                        "Payment not completed. Valid payment method not found.",
                });
            }
            resolve(true);
        });
    }

    processRegPayment(purchaseData) {
        return new Promise(async (resolve, reject) => {
            if (this.paymentGateway === "stripe") {
                // get all the details
                var displayError = document.getElementById("card-error");
                await this.stripe
                    .createPaymentMethod({
                        type: "card",
                        card: this.number,
                        billing_details: {
                            name:
                                this.state.firstName +
                                " " +
                                this.state.lastName,
                            address: {
                                line1: this.state.address,
                                // line2: ,
                                city: this.state.city,
                                state: this.state.state,
                                country: this.state.country,
                                postal_code: this.state.postcode,
                            },
                        },
                    })
                    .then(async (result) => {
                        if (result.error) {
                            displayError.textContent = result.error.message;
                            this.setState({
                                showPanel: true,
                                paymentProcessing: false,
                                errorMessage: "Payment not completed.",
                            });
                        } else {
                            // You have successfully created a new PaymentMethod
                            purchaseData.card_info = {
                                source_id: result.paymentMethod.id,
                                method: "stripe",
                            };
                            this.setState({
                                showPanel: false,
                                paymentProcessing: true,
                                errorMessage: "",
                            });
                            //code to make call to the server
                            this.props.restMS.restRequest(
                                "ps",
                                {
                                    purchaseData: purchaseData,
                                    auth: this.props.token,
                                },
                                (resp) => {
                                    //- console.log(resp);
                                    if (resp.success) {
                                        this.setState({
                                            showPanel: true,
                                            paymentProcessing: false,
                                            stepId: "payment-purchase",
                                            isAccessCode: false,
                                            reviewCompleted: true,
                                            pruchaseCompleted: true,
                                        });
                                    } else {
                                        this.setState({
                                            showPanel: true,
                                            paymentProcessing: false,
                                            stepId: "payment-review",
                                            errorMessage: resp.data,
                                        });
                                    }
                                },
                                (err) => {
                                    this.setState({
                                        showPanel: true,
                                        paymentProcessing: false,
                                        stepId: "payment-review",
                                        errorMessage: "Payment not completed.",
                                    });
                                },
                            );
                        }
                    });
            } else {
                this.setState({
                    showPanel: true,
                    paymentProcessing: false,
                    errorMessage:
                        "Payment not completed. Valid payment method not found.",
                });
            }
            resolve(true);
        });
    }

    doPayment = async () => {
        const buttonActualLabel =
        document.querySelector("#payment-purchase").value;
        document.querySelector("#payment-purchase").value = "Loading...";

        this.setState({ purchasedDisabled: false });

        let purchaseData = {
            prod: this.props.prodData,
            billing: this.props.userData,
            card_info: {},
        };
        
        if (!this.props.token || this.props.token === "") {
            purchaseData.billing = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                email: this.state.email,
                phone: this.state.phone,
                address: this.state.address,
                postcode: this.state.postcode,
                city: this.state.city,
                country: this.state.country,
                state: this.state.state,
            };
            const response = await this.processAccessPayment(purchaseData);
            console.log("payment response", response);
        } else {
            const response = await this.processRegPayment(purchaseData);
            console.log("payment response", payment);
        }
        document.querySelector("#payment-purchase").value = buttonActualLabel;

        this.setState({ purchasedDisabled: false });
    };

    displayBilling() {
        return (
            <>
                {this.state.errorMessage ? (
                    <div
                        id="payment-error"
                        style={{
                            padding: 10,
                            boxSizing: "border-box",
                            backgroundColor: "antiquewhite",
                            borderRadius: "2.5px",
                        }}
                        className="error-notification"
                    >
                        {this.state.errorMessage}
                    </div>
                ) : null}
                <form
                    name="checkout"
                    method="post"
                    className="checkout woocommerce-checkout"
                >
                    <section className="ui stackable two column grid section_wrapper">
                        <div className="column">
                            <div className="ui form">
                                <div className="field">
                                    <div className="two fields">
                                        <MsField
                                            id="first_name"
                                            label="First Name"
                                            classes=""
                                            value={this.state.firstName}
                                            onChange={this.setFirstName}
                                            showError={
                                                this.state.firstNameError
                                            }
                                        />
                                        <MsField
                                            id="last_name"
                                            label="Last Name"
                                            classes=""
                                            value={this.state.lastName}
                                            onChange={this.setLastName}
                                            showError={this.state.lastNameError}
                                        />
                                    </div>
                                </div>
                                <MsField
                                    id="email"
                                    label="Email address"
                                    classes=""
                                    value={this.state.email}
                                    onChange={this.setEmail}
                                    showError={this.state.emailError}
                                />
                                <>
                                    <label
                                        style={{ fontSize: "12px" }}
                                        for={"phone"}
                                    >
                                        Phone
                                    </label>
                                    <PhoneInput
                                        style={{ marginBottom: "10px" }}
                                        id="phone"
                                        label={"Phone"}
                                        placeholder="Enter phone number"
                                        value={this.state.phone}
                                        onChange={this.setPhone}
                                    />
                                </>
                                <MsField
                                    id="address"
                                    label="Street address"
                                    classes=""
                                    value={this.state.address}
                                    onChange={this.setAddress}
                                    showError={this.state.addressError}
                                />
                            </div>
                        </div>
                        <div className="column">
                            <div className="ui form">
                                <MsField
                                    id="postcode"
                                    label="Postal Code"
                                    classes=""
                                    value={this.state.postcode}
                                    onChange={this.setPostcode}
                                    showError={this.state.postcodeError}
                                />
                                <MsField
                                    id="city"
                                    label="Town / City"
                                    classes=""
                                    value={this.state.city}
                                    onChange={this.setCity}
                                    showError={this.state.cityError}
                                />
                                <MsDropdown
                                    id="country"
                                    label="Country"
                                    values={countries}
                                    value={this.state.country}
                                    onChange={this.setCountry}
                                    showError={this.state.countryError}
                                />
                                {this.state.country == "CA" ||
                                this.state.country == "US" ? (
                                    <MsDropdown
                                        id="state"
                                        label="State / Province"
                                        values={states[this.state.country]}
                                        value={this.state.state}
                                        onChange={this.setCityState}
                                        showError={this.state.stateError}
                                    />
                                ) : (
                                    <MsField
                                        id="state"
                                        label="State / Province"
                                        classes=""
                                        value={this.state.city}
                                        onChange={this.setCity}
                                        showError={this.state.cityError}
                                    />
                                )}
                            </div>
                        </div>
                    </section>
                    <div className="billing_buttons">
                        <div className="float-left">
                            <MsPanelButton
                                id="payment-back"
                                label="Back"
                                onClickEvent={this.goPreviousPanel}
                                classes="btn-primary alt"
                                payload="data-opt='purchase-access'"
                            />
                        </div>
                        <div className="float-right">
                            <MsPanelButton
                                id="payment-review"
                                label="Review"
                                onClickEvent={this.validateBillingFields}
                                classes="btn-primary alt"
                                payload="data-opt='purchase-access'"
                            />
                        </div>
                    </div>
                </form>
            </>
        );
    }

    formatOrderAmount(amount) {
        const currency = this.props.prodData.cur || "";
        const value = Number(amount).toFixed(2);
        return currency ? `${currency} ${value}` : value;
    }

    displayReview() {
        let gatewayPaymentForm = this.gatewayPaymentForm();

        let price = Number(this.props.prodData.price).toFixed(2);
        let tax = (
            (Number(this.props.prodData.price) *
                Number(this.props.prodData.tax)) /
            100
        ).toFixed(2);
        let total = (
            (Number(this.props.prodData.price) *
                (100 + Number(this.props.prodData.tax))) /
            100
        ).toFixed(2);

        return (
            <>
                {this.state.errorMessage ? (
                    <div
                        id="payment-error"
                        style={{
                            padding: 10,
                            boxSizing: "border-box",
                            backgroundColor: "antiquewhite",
                            borderRadius: "2.5px",
                        }}
                        className="error-notification"
                    >
                        {this.state.errorMessage}
                    </div>
                ) : null}
                <form
                    name="checkout"
                    method="post"
                    className="checkout woocommerce-checkout"
                >
                    <section className="ui stackable two column grid section_wrapper">
                        <div className="column">
                            <div className="emb-order-summary orderview" role="table" aria-label="Order summary">
                                <div className="emb-order-summary__head" role="row">
                                    <span className="emb-order-summary__head-label" role="columnheader">Product</span>
                                    <span className="emb-order-summary__head-amount" role="columnheader">Total</span>
                                </div>
                                <div className="emb-order-summary__row" role="row">
                                    <span className="emb-order-summary__label" role="cell">
                                        {this.props.prodData.title ||
                                            this.props.streamName}
                                    </span>
                                    <span className="emb-order-summary__price" role="cell">
                                        {this.formatOrderAmount(price)}
                                    </span>
                                </div>
                                <div className="emb-order-summary__row emb-order-summary__row--muted" role="row">
                                    <span className="emb-order-summary__label" role="cell">Tax (HST)</span>
                                    <span className="emb-order-summary__price" role="cell">
                                        {this.formatOrderAmount(tax)}
                                    </span>
                                </div>
                                <div className="emb-order-summary__total" role="row">
                                    <span className="emb-order-summary__total-label" role="cell">Total</span>
                                    <span className="emb-order-summary__grand-total" role="cell">
                                        {this.formatOrderAmount(total)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="column" style={{ paddingLeft: "10px" }}>
                            <div id="card-error" style={{ color: "red" }}></div>
                            <span>
                                <span className="payment-title">
                                    Credit Card
                                </span>
                                <i className="cc visa icon"></i>
                                <i className="cc amex icon"></i>
                                <i className="cc mastercard icon"></i>
                                <i className="cc discover icon"></i>
                                <i className="cc jbc icon"></i>
                                <i className="cc diners club icon"></i>
                            </span>
                            <div className="ui form">{gatewayPaymentForm}</div>
                        </div>
                    </section>
                    <div className="billing_buttons">
                        <div className="float-left">
                            <MsPanelButton
                                id="payment-billing"
                                label="Billing"
                                onClickEvent={this.showBilling}
                                classes="btn-primary alt"
                            />
                        </div>
                        <div className="float-right">
                            {this.paymentGateway !== "paypal" ? (
                                <>
                                    {this.state.purchasedDisabled ? (
                                        <MsPanelButton
                                            id="payment-purchase"
                                            label="Purchase"
                                            classes="btn-primary alt disabled"
                                            disabled={true}
                                        />
                                    ) : (
                                        <MsPanelButton
                                            id="payment-purchase"
                                            label="Purchase"
                                            onClickEvent={this.doPayment}
                                            classes="btn-primary alt"
                                        />
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </form>
            </>
        );
    }

    displayPayment() {
        if (this.state.paymentProcessing) {
            return (
                <MSStreamLoader
                    divId="payment-processing-loader"
                    width="100%"
                    height="200px"
                />
            );
        }

        let orderCompletedStyle = {
            paddingTop: "1px",
        };
        let thankYouStyle = {
            fontSize: "20px",
            margin: "10px",
        };
        let pStyle = {
            marginTop: "20px",
        };
        return (
            <>
                <div className="order-completed" style={orderCompletedStyle}>
                    <h1 style={thankYouStyle}>
                        Thanks you. Your order has been recieved!
                    </h1>
                    {!this.state.isAccessCode ? (
                        <>
                            <p style={pStyle}>
                                You have been register on{" "}
                                {this.props.prodData.title || this.props.streamName}. 
                                To watch the stream please click on the button below.
                            </p>
                            <MsPanelButton
                                id="view-streaming"
                                label="View Stream"
                                onClickEvent={this.goSuccessPanel}
                                classes="btn-primary alt"
                            />
                        </>
                    ) : (
                        <>
                            <div className="access_code_wrapper">
                                <p>Your access has been sent to:</p>
                                <h2>
                                    <code>{this.state.email}</code>
                                </h2>
                            </div>
                            <p>
                                To watch the stream click on
                                the button below and enter your{" "}
                                <i>Access Code.</i>
                            </p>
                            <MsPanelButton
                                id="view-streaming"
                                label="Enter Access Token"
                                onClickEvent={this.goPreviousPanel}
                                classes="btn-primary alt"
                            />
                        </>
                    )}
                </div>
            </>
        );
    }

    async loadStripeFunction(self, key) {
        if (self.stripeMounted) {
            return;
        }
        if (self.stripeInitPromise) {
            return self.stripeInitPromise;
        }

        self.stripeInitPromise = (async () => {
        const cardNumberEl = document.getElementById("card-number");
        const cardExpiryEl = document.getElementById("card-expiry");
        const cardCvcEl = document.getElementById("card-cvc");
        if (!cardNumberEl || !cardExpiryEl || !cardCvcEl) {
            return;
        }

        self.stripe = await loadStripe(key);
        if (!self.stripe) {
            return;
        }
        var elements = self.stripe.elements();
        // Custom Styling
        var style = {
            base: {
                color: "#32325d",
                lineHeight: "24px",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4",
                },
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        };
        // card number
        var cardNumber = elements.create("cardNumber", { style: style });
        cardNumber.mount("#card-number");
        self.number = cardNumber;
        // Handle real-time validation errors from the card Element.
        var displayNumberError = document.getElementById("card-number-error");
        cardNumber.on("change", function (event) {
            // var displayError = document.getElementById('card-error');
            if (event.error) {
                displayNumberError.textContent = event.error.message;
            } else {
                displayNumberError.textContent = "";
            }
        });

        var cardExpiry = elements.create("cardExpiry", { style: style });
        cardExpiry.mount("#card-expiry");
        self.expiry = cardExpiry;

        var displayExpiryError = document.getElementById("card-expiry-error");
        cardExpiry.on("change", function (event) {
            // var displayError = document.getElementById('card-error');
            if (event.error) {
                displayExpiryError.textContent = event.error.message;
            } else {
                displayExpiryError.textContent = "";
            }
        });

        var cardCvc = elements.create("cardCvc", { style: style });
        cardCvc.mount("#card-cvc");
        self.cvc = cardCvc;
        var displayCvcError = document.getElementById("card-cvc-error");
        cardCvc.on("change", function (event) {
            // var displayError = document.getElementById('card-error');
            if (event.error) {
                displayCvcError.textContent = event.error.message;
            } else {
                displayCvcError.textContent = "";
            }
        });

        self.stripeMounted = true;
        })();

        try {
            await self.stripeInitPromise;
        } finally {
            self.stripeInitPromise = null;
        }
    }

    async loadPaypalFunction(self, key) {
        if (self.paypalMounted) {
            return;
        }

        const paypalContainer = document.getElementById("paypal-button-container");
        if (!paypalContainer) {
            return;
        }

        console.log("PAYPAL FUNCTION");

        let userData={};
        if( Object.keys(this.props.userData).length == 0 ) {
            userData = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                email: this.state.email,
                phone: this.state.phone,
                address: this.state.address,
                postcode: this.state.postcode,
                city: this.state.city,
                state: this.state.state
            }
        } else {
            userData = this.props.userData;
        }

        let productData = this.props.prodData;

        console.log('user data ==>>', userData);
        console.log('prod data ==>>', productData);

        const self_props = self.props;

        await loadScript({
            "client-id": key,
            currency: self.props.prodData.cur.toString().trim(),
            intent: "authorize",
        })
            .then((paypal) => {
                paypal
                    .Buttons({
                        createOrder: (data, actions) => {
                            const price = Number(self.props.prodData.price) || 0;
                            const tax = Number(self.props.prodData.tax) || 0;
                            const total = (
                                (price * (100 + tax)) /
                                100
                            ).toFixed(2);
                            if (!total || Number(total) <= 0) {
                                return Promise.reject(
                                    new Error("Invalid payment amount"),
                                );
                            }
                            return actions.order.create({
                                intent: "AUTHORIZE",
                                purchase_units: [
                                    {
                                        amount: {
                                            currency_code:
                                                self.props.prodData.cur
                                                    .toString()
                                                    .trim(),
                                            value: total,
                                        },
                                    },
                                ],
                            });
                        },
                        onApprove: (data, actions) => {
                            const token = self.props.token;

                            const submitPurchase = (authorizationID) => {
                                let purchaseData = {
                                        prod: productData,
                                        billing: userData, // was self.userData
                                        card_info: {
                                            orderID: data.orderID,
                                            authorizationID: authorizationID,
                                            method: "paypal",
                                        },
                                    };

                                    self.setState({
                                        showPanel: false,
                                        paymentProcessing: true,
                                        errorMessage: "",
                                    });

                                    // making request to the test endpoint
                                    // self.restMS.restRequest("test", {purchaseData: purchaseData},
                                    if (!token || token === "") {
                                        self.props.restMS.restRequest(
                                            "pac",
                                            { purchaseData: purchaseData },
                                            (resp) => {
                                                console.log(resp);
                                                if (resp.success) {
                                                    self.setState({
                                                        showPanel: true,
                                                        paymentProcessing: false,
                                                        stepId: "payment-purchase",
                                                        isAccessCode: true,
                                                        reviewCompleted: true,
                                                        pruchaseCompleted: true,
                                                    });
                                                } else {
                                                    self.setState({
                                                        showPanel: true,
                                                        paymentProcessing: false,
                                                        stepId: "payment-review",
                                                        errorMessage: resp.data,
                                                    });
                                                }
                                            },
                                            (err) => {
                                                self.setState({
                                                    showPanel: true,
                                                    paymentProcessing: false,
                                                    stepId: "payment-review",
                                                    errorMessage:
                                                        "Payment not completed.",
                                                });
                                            },
                                        );
                                    } else {
                                        self.props.restMS.restRequest(
                                            "ps",
                                            {
                                                purchaseData: purchaseData,
                                                auth: token,
                                            },
                                            (resp) => {
                                                if (resp.success) {
                                                    self.setState({
                                                        showPanel: true,
                                                        paymentProcessing: false,
                                                        stepId: "payment-purchase",
                                                        isAccessCode: false,
                                                        reviewCompleted: true,
                                                        pruchaseCompleted: true,
                                                    });
                                                } else {
                                                    //- console.log(resp);
                                                    self.setState({
                                                        showPanel: true,
                                                        paymentProcessing: false,
                                                        stepId: "payment-review",
                                                        errorMessage: resp.data,
                                                    });
                                                }
                                            },
                                            (err) => {
                                                self.setState({
                                                    showPanel: true,
                                                    paymentProcessing: false,
                                                    stepId: "payment-review",
                                                    errorMessage:
                                                        "Payment not completed.",
                                                });
                                            },
                                        );
                                    }
                            };

                            const getAuthorizationId = (orderDetails) => {
                                const payments =
                                    orderDetails?.purchase_units?.[0]?.payments;
                                return (
                                    payments?.authorizations?.[0]?.id || null
                                );
                            };

                            // Sandbox often auto-authorizes on approve; calling authorize() again returns 422.
                            return actions.order
                                .get()
                                .then((orderDetails) => {
                                    let authorizationID =
                                        getAuthorizationId(orderDetails);
                                    if (authorizationID) {
                                        return authorizationID;
                                    }
                                    return actions.order
                                        .authorize()
                                        .then((authorization) =>
                                            getAuthorizationId(authorization),
                                        );
                                })
                                .then((authorizationID) => {
                                    if (!authorizationID) {
                                        throw new Error(
                                            "PayPal authorization ID missing",
                                        );
                                    }
                                    submitPurchase(authorizationID);
                                });
                        },
                        onError: (err) => {
                            console.error("PayPal checkout error", err);
                            self.setState({
                                showPanel: true,
                                paymentProcessing: false,
                                stepId: "payment-review",
                                errorMessage:
                                    "PayPal payment could not be completed. Use a sandbox buyer account or try again.",
                            });
                        },
                        // onCancel:  (data:any, actions:any )=> {
                        //
                        //   alert("ORDER IS CANCELLED ");
                        // }
                    })
                    .render("#paypal-button-container");
                self.paypalMounted = true;
            })
            .catch((err) => {
                console.error("failed to load the PayPal JS SDK script", err);
                self.paypalMounted = false;
            });
    }

    getPaymentStepStatus(stepId) {
        const order = PAYMENT_STEPS.map((s) => s.id);
        const currentIndex = order.indexOf(this.state.stepId);
        const stepIndex = order.indexOf(stepId);

        if (stepIndex < currentIndex) {
            return "completed";
        }
        if (stepIndex === currentIndex) {
            return "current";
        }
        if (
            (stepId === "payment-billing" && this.state.billingCompleted) ||
            (stepId === "payment-review" && this.state.reviewCompleted) ||
            (stepId === "payment-purchase" && this.state.pruchaseCompleted)
        ) {
            return "completed";
        }
        return "upcoming";
    }

    renderPaymentProgress() {
        return (
            <nav className="emb-payment-progress" aria-label="Checkout progress">
                <div className="emb-payment-progress__list" role="list">
                    {PAYMENT_STEPS.map((step, index) => {
                        const status = this.getPaymentStepStatus(step.id);
                        const isCompleted = status === "completed";
                        const isCurrent = status === "current";
                        const prevCompleted =
                            index > 0 &&
                            this.getPaymentStepStatus(PAYMENT_STEPS[index - 1].id) === "completed";

                        return (
                            <React.Fragment key={step.id}>
                                {index > 0 ? (
                                    <div
                                        className={`emb-payment-progress__line${
                                            prevCompleted ? " is-complete" : ""
                                        }`}
                                        aria-hidden="true"
                                    />
                                ) : null}
                                <div
                                    className={`emb-payment-progress__step is-${status}`}
                                    role="listitem"
                                    aria-current={isCurrent ? "step" : undefined}
                                    data-text-section={step.id}
                                    data-ul-section={step.id}
                                >
                                    <div className="emb-payment-progress__indicator">
                                        {isCompleted ? (
                                            <MsFeatherIcon
                                                name="check"
                                                size={18}
                                                className="emb-payment-progress__icon"
                                                title={`${step.title} complete`}
                                            />
                                        ) : (
                                            <MsFeatherIcon
                                                name={step.icon}
                                                size={18}
                                                className="emb-payment-progress__icon"
                                                title={step.title}
                                            />
                                        )}
                                        <span className="emb-payment-progress__badge" aria-hidden="true">
                                            {step.number}
                                        </span>
                                    </div>
                                    <div className="emb-payment-progress__labels">
                                        <span className="emb-payment-progress__title">{step.title}</span>
                                        <span className="emb-payment-progress__desc">{step.description}</span>
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
            </nav>
        );
    }

    render() {
        if (!this.state.showPanel) {
            return (
                <MSStreamLoader
                    divId="player_container_emb"
                    width="100%"
                    height="100%"
                />
            );
        }

        let component = null;
        switch (this.state.stepId) {
            case "payment-billing":
                component = this.displayBilling();
                break;
            case "payment-review":
                component = this.displayReview();
                break;
            case "payment-purchase":
                component = this.displayPayment();
                break;
        }

        return (
            <div className="wpstream_payment_backgorund">
                <div className="embv_checkout_page">
                    {this.renderPaymentProgress()}
                    <div id="modal-container">{component}</div>
                </div>
            </div>
        );
    }
}
export default injectIntl(MSStreamPurchase);
